import { Component, Injector, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, Channel, ChannelAPIs, ChannelService, ConfirmationComponent } from 'lib-trend-core';

@Component({
    selector: 'channel-apis-component',
    templateUrl: './channel-apis.component.html',
    styleUrls: ['./channel-apis.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelAPIsComponent extends AbstractComponent implements OnInit {

  @Input() channel!: Channel;

  constructor(
    injector: Injector,
    private channelService: ChannelService,
    public dialog: MatDialog,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.loadingContent = false;
  }

  generateNewCredentials() {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Boolean(result) === true) {
        this.channelService.generateNewAPITokenChannel(this.channel._id).subscribe({
          next: (channelAPIs: ChannelAPIs) => {
            this.channel.apis = channelAPIs;
            this.alertService.success(this.t('channel.apis.tokenGeneratedSuccess'));
          },
          error: err => this.alertService.error(err.error.message)
        })
      }
    });
  }

  copyContentUUID(): void {
    navigator.clipboard.writeText(this.channel.apis.uuid);
    this.alertService.success(this.t('channel.apis.uuidCopied'));
  }

  copyContentToken(): void {
    navigator.clipboard.writeText(this.channel.apis.token);
    this.alertService.success(this.t('channel.apis.tokenCopied'));
  }

}
